import { Css, RightPaneLayout, ScrollableContent, Switch } from "@homebound/beam";
import { useState } from "react";
import { SearchBox } from "src/components";
import { BidPackageStatus } from "src/generated/graphqlTypes";
import { PageBidPackageDetailFragment } from "src/routes/bids/BidPackageDetailPage.generated";
import { TableActions } from "src/routes/layout/TableActions";
import { PlanBasedBidsTable } from "./PlanBasedBidsTable";
import { UnitBasedBidsTable } from "./UnitBasedBidsTable";
import { getBidPackageTradesWithEstimate } from "./utils";

type BidsTabProps = {
  bidPackage: PageBidPackageDetailFragment;
};

export function BidsTab({ bidPackage }: BidsTabProps) {
  const [searchFilter, setSearchFilter] = useState<string | undefined>("");
  const [showPlanUsage, setShowPlanUsage] = useState(!bidPackage.isUnitBased);

  // Get all trades without contracts or with draft contracts
  const trades = getBidPackageTradesWithEstimate(bidPackage);
  const requestsWithEditableBids = trades.filter((trade) => {
    // If the bid package is awarded, we don't allow edits
    if (bidPackage.status.code === BidPackageStatus.Awarded) {
      return false;
    }
    const bidContractRevision = trade.bidContractRevision;
    return !bidContractRevision || bidContractRevision.canEdit.allowed;
  });

  return (
    <>
      <TableActions>
        <SearchBox onSearch={setSearchFilter} />
        {bidPackage.isUnitBased && (
          <Switch label="Show Plan Usage" selected={showPlanUsage} onChange={setShowPlanUsage} />
        )}
      </TableActions>
      <div css={Css.h100.$}>
        <ScrollableContent virtualized>
          <RightPaneLayout>
            <div css={Css.h100.$}>
              {!showPlanUsage ? (
                <UnitBasedBidsTable
                  bidPackage={bidPackage}
                  searchFilter={searchFilter}
                  requestsWithEditableBids={requestsWithEditableBids}
                />
              ) : (
                <PlanBasedBidsTable
                  bidPackage={bidPackage}
                  searchFilter={searchFilter}
                  requestsWithEditableBids={requestsWithEditableBids}
                />
              )}
            </div>
          </RightPaneLayout>
        </ScrollableContent>
      </div>
    </>
  );
}

export function getOptionsKey(
  opt: {
    __typename?: "ReadyPlanOption" | undefined;
    id: string;
  }[],
) {
  return opt
    .sortByKey("id")
    .map((o) => o.id)
    .join(",");
}
